<tt-page *ngIf="!!page" class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-select
            ttLabel="choice_prod_name"
            [(ttModel)]="page.choice_prod_id"
            (ttModelChange)="onPageChanged($event, 'choice_prod_id')"
            [ttData]="selectListProductChoices"
            ttDataId="prod_id"
            ttDataName="prod_name"
            [ttShowClearButton]="page.choice_prod_id !== 'ALL'"
            ttClearValue="ALL"
        ></tt-select>
        <tt-select
            ttLabel="model_name"
            [(ttModel)]="page.model_id"
            (ttModelChange)="onPageChanged($event, 'model_id')"
            [ttData]="selectListModels"
            ttDataId="model_id"
            ttDataName="model_name"
            [ttShowClearButton]="page.model_id !== 'ALL'"
            ttClearValue="ALL"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-bars" ttType="primary" ttGoto="models"></tt-form-field-button>
                <tt-form-field-button *ngIf="page.model_id !== 'ALL'" ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="modelmenu" [ttGotoParms]="{ model_id: page.model_id }"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-button ttText="choicepossrulesrun_execute" (ttClick)="execute()" [ttLoading]="executing" ttTextAlign="center" ttType="primary" ttIcon="fas fa-sync-alt"></tt-button>
        <tt-tabs [(ttSelectedId)]="selectedView">
            <tt-tab ttId="COUNT" ttLabel="gb_choicepossrulesrun_count"></tt-tab>
            <tt-tab ttId="PRODUCTS" ttLabel="gb_choicepossrulesrun_products"></tt-tab>
        </tt-tabs>
    </tt-card>
    <tt-list *ngIf="selectedView === 'COUNT'" class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListCounts" ttBadge="badgeinfo"></tt-list>
    <tt-list *ngIf="selectedView === 'PRODUCTS'" class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListProducts" ttBadge="badgeinfo"></tt-list>
</tt-page>
